<fgb-mobile-nav-menu></fgb-mobile-nav-menu
><ng-container *notInPopulation="[populations.TicketTransfer]">
  <ng-container *ifScreenSize="screenType.Desktop">
    <ng-container *ngIf="{ card: card$ | async, memberDetail: memberDetails$ | async } as memberCard">
      <fgb-banner
        [title]="'home.page.title' | translate: { name: memberCard.memberDetail?.FirstName }"
        [subtitle]="memberCard.card?.ProductCode + ' - ' + memberCard.memberDetail?.ExternalRefNumber"
        [showBtn]="true"
        [isHomePage]="true"
      />
    </ng-container>
  </ng-container>

  <ng-container *ifScreenSize="screenType.Mobile">
    <fgb-mobile-page-header [isHomePage]="true"></fgb-mobile-page-header>
  </ng-container>

  <div class="mt-lg-3 mobile-container pe-lg-0 pt-lg-0 pt-3">
    <fgbcl-loyalty-feed-list></fgbcl-loyalty-feed-list>
    <div class="container">
      <fgb-vouchers></fgb-vouchers>
    </div>
  </div>

  <!--Scorecard carousel-->
  <div class="mt-4">
    <fgbcl-scorecard-carousel [link]="'badges'" [icon]="'chevron_right'" [showAllView]="true"></fgbcl-scorecard-carousel>

    <ng-container *ngIf="scorecard$ | async as activeScorecards">
      <a *ngIf="activeScorecards.length > 0" class="w-100 d-flex justify-content-center" [routerLink]="'/challenges'">
        <div class="view-all-btn">{{ 'home.view.all.button' | translate }}</div>
      </a>
    </ng-container>
  </div>

  <div class="container">
    <fgbcl-featured-rewards></fgbcl-featured-rewards>

    <ng-container *ngIf="mixedLoyaltyItems$ | async as mixedLoyaltyItems">
      <a *ngIf="mixedLoyaltyItems.length" class="w-100 d-flex justify-content-center mt-3" [routerLink]="'/rewards/marketplace'">
        <div class="view-all-btn">{{ 'home.view.all.button' | translate }}</div>
      </a>
    </ng-container>

    <fgb-campaigns-v2-offers-list [showAllOffers]="true"></fgb-campaigns-v2-offers-list>

    <!-- Savings Component -->
    <ng-container *inPopulation="[populations.Default]">
      <div class="savings-component mt-4">
        <div
          class="savings-background d-lg-block d-none"
          [style.background-image]="'url(' + ('images/exclusiveoffersd.png' | contentAssetImage) + ')'"
        ></div>
        <div
          class="savings-background d-lg-none d-block"
          [style.background-image]="'url(' + ('images/exclusiveoffersm.png' | contentAssetImage) + ')'"
        ></div>
        <div class="savings-content">
          <div class="savings-text mt-lg-0 mt-auto flex-column d-flex">
            <h2 class="savings-title">{{ 'home.savings.title' | translate: { fgbdefault: 'Exclusive Offers' } }}</h2>
            <p class="savings-description">
              {{
                'home.savings.description'
                  | translate: { fgbdefault: 'Benefit from exclusive weekly offers and discounts from leading brands.' }
              }}
            </p>
            <button class="savings-button mt-lg-auto" [routerLink]="['/offers']">
              {{ 'home.savings.view.offers.button' | translate: { fgbdefault: 'View My Offers' } }}
            </button>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *notInPopulation="[populations.Digital]">
      <!-- Announcements -->
      <fgbcl-announcements></fgbcl-announcements>
    </ng-container>
  </div>
</ng-container>

<ng-container *inPopulation="[populations.TicketTransfer]">
  <fgb-ticket-transfer-page></fgb-ticket-transfer-page>
</ng-container>
